/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleFixedCustomRate extends models.BillingRuleCalculate {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleFixedCustomRate");
    }

    getFixupPrototypeFunction() { return BillingRuleFixedCustomRate.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleFixedCustomRate>): BillingRuleFixedCustomRate {
        let obj = Object.assign(new BillingRuleFixedCustomRate(), model);
        BillingRuleFixedCustomRate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleFixedCustomRate>): BillingRuleFixedCustomRate {
        if (!model) return null;
        return BillingRuleFixedCustomRate.newInstance(<BillingRuleFixedCustomRate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleFixedCustomRate) {
        if (!obj) return;

        models.BillingRuleFixedCustomRate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleFixedCustomRate): boolean {
        if (models.BillingRuleCalculate.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleFixedCustomRate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.amount === undefined) {
            this.amount = 0;
        }
    }

    /**
     * Amount of the billing rule
     */
    amount: number;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

}
